import { createSlice } from "@reduxjs/toolkit";
const mergeMessages = (current = [], incoming = []) => {
  const map = new Map();

  [...current, ...incoming].forEach((msg) => {
    const key = Number(msg?.idmesagges || msg?.id);
    if (!key) return;

    const existing = map.get(key) || {};
    map.set(key, { ...existing, ...msg });
  });

  return Array.from(map.values()).sort((a, b) => {
    const aId = Number(a?.idmesagges || a?.id || 0);
    const bId = Number(b?.idmesagges || b?.id || 0);

    if (aId !== bId) return aId - bId;

    const aTime = new Date(
      a?.timestamp || a?.created_at || a?.date || 0
    ).getTime();

    const bTime = new Date(
      b?.timestamp || b?.created_at || b?.date || 0
    ).getTime();

    return aTime - bTime;
  });
};

const mesaggesSlice = createSlice({
  name: "mesagges",
  initialState: {
    bySuggestionId: {},
    activeSuggestionId: null,
    isFetching: false,
    error: false,
  },
  reducers: {
    mesaggesStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },

    mesaggesSuccess: (state, action) => {
      state.isFetching = false;

      const payload = action.payload || {};
      const { suggestionId, messages } = payload;

      if (!suggestionId) return;

      state.bySuggestionId[suggestionId] = mergeMessages(
        state.bySuggestionId[suggestionId] || [],
        Array.isArray(messages) ? messages : []
      );
    },

    mesaggesFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },

    addMesagges: (state, action) => {
      const message = action.payload;
      const suggestionId = Number(message?.id_suggestions);

      if (!suggestionId) return;

      if (!state.bySuggestionId[suggestionId]) {
        state.bySuggestionId[suggestionId] = [];
      }

      state.bySuggestionId[suggestionId] = mergeMessages(
        state.bySuggestionId[suggestionId],
        [message]
      );

      state.isFetching = false;
    },

    setActiveSuggestionId: (state, action) => {
      state.activeSuggestionId = action.payload;
    },

    clearActiveSuggestionId: (state) => {
      state.activeSuggestionId = null;
    },

    markConversationRead: (state) => {
      state.isFetching = false;
    },

    logoutMesagges: (state) => {
      state.bySuggestionId = {};
      state.activeSuggestionId = null;
      state.isFetching = false;
      state.error = false;
    },
  },
});

export const {
  mesaggesStart,
  mesaggesSuccess,
  mesaggesFailure,
  addMesagges,
  setActiveSuggestionId,
  clearActiveSuggestionId,
  markConversationRead,
  logoutMesagges,
} = mesaggesSlice.actions;

export default mesaggesSlice.reducer;